import { Injectable } from '@angular/core';
import { IFareFamily } from "libraries/service/resources/booking/interfaces/IGetBookings";
import {
    FareComponentInBookingType,
    PriceDetailInBookingType, PriceInOfferType,
    ResponseForConvertOfferAfx2jsonType
} from "@afidium/ts-facade";

export interface IFareFamilyCollection {
    [key: string]: IFareFamily
}

@Injectable()
export class AncillaryServicesPageService {

    public getFareFamiliesWithUpdatedSyscodeValue(fareFamilyCollection: IFareFamilyCollection, newResponse: ResponseForConvertOfferAfx2jsonType): IFareFamilyCollection {
        const output: IFareFamilyCollection = {};
        Object.entries(fareFamilyCollection)
            .forEach((value: [string, IFareFamily]): void => {
                const key: string = value[0];
                const fareFamily: IFareFamily = value[1];

                output[key] = {
                    ...fareFamily,
                    syscode : this.getRelatedSyscodeValue(key, newResponse),
                };

            });
        return output;
    }

    public getRelatedSyscodeValue(fareFamilyXId: string, newResponse: ResponseForConvertOfferAfx2jsonType): string {
        // FF would be in a price with rate in its detail (not always first price in array, 1st nor detail in array)
        const relatedPrice: PriceInOfferType = newResponse.offer.priceArray
            .find((price: PriceInOfferType): boolean => {
                return price.cost.detailArray.some((detail: PriceDetailInBookingType): boolean => Boolean(detail.rate));
            });
        const relatedDetail: PriceDetailInBookingType = relatedPrice ?
            relatedPrice.cost.detailArray
                .find((detail: PriceDetailInBookingType): boolean => Boolean(detail.rate))
            : null;
            const fareComponent: FareComponentInBookingType = relatedDetail ?
                relatedDetail.rate.fareComponentArray
                    .find((fareComponentItem: FareComponentInBookingType): boolean => fareComponentItem.fareFamily?.xRef === fareFamilyXId) :
                null;


            return fareComponent?.fareFamily?.syscode?.value || fareFamilyXId;
        }

}
